import React, { FC } from 'react';
import { tint } from 'src/shared/globals';
import BiCircle from 'src/shared/icons/circle.svg';
import styled from 'styled-components';

// Re-export ui-widgets badge components
export * from './betaBadge';
export * from './betaBannerIcon';

export interface BadgeProps {
    badgeColor: string;
    borderColor?: string;
    color?: string;
    showCircle?: boolean;
    children?: React.ReactNode;
    className?: string;
}

const StyledBadge = styled.div<{ $badgeColor: string; $borderColor?: string; $color?: string }>`
    background-color: ${(props) => props.$badgeColor};
    display: inline-block;
    width: fit-content;
    height: 1.7rem;
    align-items: center;
    border: 1px solid ${(props) => props.$borderColor || '#fff'};
    border-radius: 4px;
    font-size: 11px;
    padding-left: 5px;
    padding-right: 8px;
    z-index: 1;
    line-height: 1.6rem;
    color: ${(props) => props.$color || 'auto'};
`;

const Circle = styled(BiCircle)`
    margin-right: 2px;
`;

export const Badge: FC<BadgeProps> = ({ badgeColor, borderColor, color, showCircle, children, className }) => {
    return (
        <StyledBadge className={className} $badgeColor={badgeColor} $borderColor={borderColor} $color={color}>
            {showCircle && <Circle color={tint(badgeColor, -16)} />}
            {children}
        </StyledBadge>
    );
};

interface BadgeColorProps {
    children?: string;
    className?: string;
}

export const BadgeGreen: FC<BadgeColorProps> = (props) => <Badge badgeColor='#aee9d1'>{props.children}</Badge>;

export const BadgeYellow: FC<BadgeColorProps> = (props) => <Badge badgeColor='#ffea8a'>{props.children}</Badge>;

export const BadgeRed: FC<BadgeColorProps> = (props) => (
    <Badge badgeColor='#EC7063' color='white'>
        {props.children}
    </Badge>
);

export const BadgeGray: FC<BadgeColorProps> = (props) => <Badge badgeColor='#dfe3e8'>{props.children}</Badge>;

export const BadgeBlue: FC<BadgeColorProps> = (props) => (
    <Badge className={props.className} badgeColor='#CCCCFF'>
        {props.children}
    </Badge>
);
